module.exports = __webpack_public_path__ + "img/23.72a10574.jpg";